module.exports = __webpack_public_path__ + "static/media/monte-verde-mg.d3c5a795.jpg";